module.exports = __webpack_public_path__ + "static/media/composer-previous.19651528.svg";